import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { Platform } from 'models/casino';

export type GroupedPlatform = {
  platform: string;
  image: string;
  games: Platform[];
};

export interface CasinoState {
  platforms: GroupedPlatform[];
}

const initialState: CasinoState = {
  platforms: [],
};

const casinoSlice = createSlice({
  name: 'casino',
  initialState,
  reducers: {
    setPlatforms: (state, action: PayloadAction<Platform[]>) => {
      const platforms = action.payload;
      const groupedToArray = Object.values(
        platforms.reduce<Record<string, GroupedPlatform>>((acc, game) => {
          const { platform, image } = game;
          if (!acc[platform]) {
            acc[platform] = {
              platform,
              image,
              games: [],
            };
          }
          acc[platform].games.push(game);
          return acc;
        }, {}),
      );
      state.platforms = groupedToArray;
    },
  },
});

export const { setPlatforms } = casinoSlice.actions;
export const selectPlatforms = (state: RootState) => state.casino.platforms;
// NOTE: Reducer
export default casinoSlice.reducer;
